/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function BenefisDeleteDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { benefisForEdit, actionsLoading } = useSelector(
    (state) => ({
      benefisForEdit: state.benefis.benefisForEdit,
      actionsLoading: state.benefis.actionsLoading,
    }),
    shallowEqual
  );

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">
          Delete Benefis Data
        </Modal.Title>
      </Modal.Header>
    </>
  );
}
